import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOnProcessAccountingDTO from "../../../models/DTO/IOnProcessAccountingDTO";
import IProcessAccountingDTO from "../../../models/DTO/IProcessAccountingDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IAccounting from "../../../models/IAccounting";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./AccountingSidebar.scss";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    accounting: IAccounting;
};

type State = {
    createActive: boolean;
    accounting: IAccounting;
};

class AccountingSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            accounting: this.props.accounting,
            createActive: false,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.AccountingOnProcessAccounting, this.onProcessAccounting);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.AccountingOnProcessAccounting, this.onProcessAccounting);
    }

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    save = () => {
        const payload: IProcessAccountingDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            accounting: {
                ...this.state.accounting,
            },
            orderGuids: [],
            processOrderGuids: false,
        };

        this.props.socket.emit(EndpointsEnum.AccountingProcessAccounting, payload);

        this.setState({
            createActive: true,
        });
    };

    onProcessAccounting = (data: IOnProcessAccountingDTO) => {
        const notification: INotification = {
            message: "successfully_processed_accounting",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.cancel(true);
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const accounting = this.state.accounting;

        // @ts-expect-error
        accounting[name] = value;

        this.setState({ accounting });
    };

    render() {
        return (
            <div className={"AccountingSidebar p-2"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle
                        className={"mb-2"}
                        leftIconName={"fad fa-abacus"}
                        title={this.props.accounting.name!}
                        disableTranslation={true}
                    />
                    <hr />
                </div>

                <div className={"col-12"}>
                    <div>
                        <OwLabel title={"invoice_top_line"} />
                        <OwInputWrapper name={"qbd_invoice_top_line"} fn={this.handleChange} value={this.state.accounting.qbd_invoice_top_line} />
                    </div>
                </div>

                <div>
                    <OwButton title={"save"} fn={this.save} active={this.state.createActive} disableOnActive={true} />
                </div>
            </div>
        );
    }
}

export default AccountingSidebar;
